import {BasePageLayout} from "../components/grouping/BasePageLayout";
import {useArticles} from "../api/articleapi";
import {Section} from "../components/grouping/Section";
import {Button, Col, Row} from "react-bootstrap";

export function HomePage(props) {
    const {articles} = useArticles();
    return <BasePageLayout title={'Artikels'}>
        <div className={'p-2'}>
            <ArticleList articles={articles}/>
        </div>

    </BasePageLayout>
}


function ArticleList(props) {
    const {articles} = props;
    return articles?.sort((a1, a2) => new Date(a2.timeCreated) - new Date(a1.timeCreated))?.map(a => <Article key={a.id}
                                                                                                              article={a}/>)
}

function Article(props) {
    const {article} = props;
    return <Button href={"/articleview/" + article.id} className={'text-black border-0 p-0 m-0 w-100 bg-transparent'}>
        <Row xs={12} className={'g-0 border border-1 border rounded-2 shadow  p-2 mt-2'}>
            <Col xs={12}>
                <h5>{article?.title}</h5>
                <hr/>
            </Col>
            <Col xs={12} className={'text-start'}>
                <div dangerouslySetInnerHTML={{__html: article?.description.split('<hr>')[0]}}>

                </div>
            </Col>
        </Row>
    </Button>
}

